import { render } from "./Slider.vue?vue&type=template&id=51382460&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=51382460&scoped=true&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51382460"]])

export default __exports__